<script setup>
import { ref } from "vue";
import { useOverflow } from "vui/composables/overflow";

defineProps(["lineClamp"]);

const content = ref(null);
const expanded = ref(false);
const overflow = useOverflow(content);
</script>

<template>
	<div
		ref="content"
		class="vui-expandable"
		:class="{ expanded, overflow }"
		:style="{ '-webkit-line-clamp': expanded ? 'unset' : lineClamp }"
		@click="expanded = expanded ? false : overflow"
	>
		<slot></slot>
	</div>
</template>
